export default __webpack_public_path__ + "static/media/6.ad6af5b4.jpg";